import { format } from "date-fns";

export const COLUMNS = [
    {
        Header: 'Ime',
        accessor: 'firstName'

    },
    {
        Header: 'Prezime',
        accessor: 'lastName'
    },
    {
        Header: 'Email',
        accessor: 'email'
    },
]